import { render, staticRenderFns } from "./KennelDetails.vue?vue&type=template&id=1cbaca43"
import script from "./KennelDetails.vue?vue&type=script&lang=ts"
export * from "./KennelDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports